import { histogramPlot, periodInput } from "../definitionHelpers";
import { COLOR_RULE, MA_TYPE } from "../indicatorTypes";
import { fillMacdLine } from "../math/macd";
import { fillMovingAverage } from "../math/movingAverages";
import { valuesReader } from "../math/priceSources";

/**
 * OsMA (research §1.4). Not in TradingView, the classic MetaTrader formula:
 * the MACD line (as in MACD) minus its SMA over Signal SMA; one colour as in PO.
 */
export default {
  id: "osma",
  name: "OsMA",
  isOscillator: true,
  inputs: [
    periodInput("fastEma", "Fast EMA", 12, { max: 250 }),
    periodInput("slowEma", "Slow EMA", 26, { max: 250 }),
    periodInput("signalSma", "Signal SMA", 9, { max: 250 }),
  ],
  plots: [
    histogramPlot("value", "Main Line", COLOR_RULE.SINGLE),
  ],
  buffers: ["fastAverage", "slowAverage", "macd", "signal"],
  levels: [],

  calculate: (bars, { fastEma, slowEma, signalSma }, series, fromIndex) => {
    fillMacdLine({
      bars,
      fastPeriod: fastEma,
      slowPeriod: slowEma,
      averages: { fastEma: series.fastAverage, slowEma: series.slowAverage },
      target: series.macd,
      fromIndex,
    });
    fillMovingAverage({
      type: MA_TYPE.SMA,
      read: valuesReader(series.macd),
      target: series.signal,
      period: signalSma,
      fromIndex,
      toIndex: bars.length,
    });

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.value[index] = series.macd[index] - series.signal[index];
    }
  },
};
